// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__b4EI7","header":"PatientBlock_header__2RXeD","label":"PatientBlock_label__2SKnu","option":"PatientBlock_option__3uJXX"};